SlideView  = require("views/slide")
YouTubeAPI = require("lib/youtube-api")
device     = require("lib/device")

class YoutubeVideoEmbedView extends SlideView
  template: require("./template")

  events:
    "iostap .btn-done": "submit"
    "iostap": "playVideo"
    
  needCaptions: ->
    @options.data.videoId.indexOf('cc_load_policy') > -1

  serialize: ->
    data = super
    data.submitUp = @needCaptions()
    data.continueBtnText = i18n("video.skip-video")
    data.skipButton = if data?.showSkipButton? then data.showSkipButton else true


    data

  render: ->
    super

    @player = null
    @waitForAPI()

  beforeShow: (lmsMode) ->
    @trigger("ui", lightbox: true, flexibleHeight: true)
    @setState("loading", "video")
    
    if device.platform != "browser"
      Application.publish("event:rotation-unlock") {}
    
    if lmsMode
      @options.data.autoplay = !lmsMode;

    if @options.data.autoplay and window.location.href.split("thumbnail=true").length isnt 2
      @playVideo()

  beforeHide: ->
    window.clearTimeout @waitForAPITimeout
    window.clearTimeout @checkForPlayerTimeout

    @player?.stopVideo?()

    if device.platform != "browser"
      Application.publish("event:rotation-lock") {}

    @trigger("ui", lightbox: false, flexibleHeight: false)

  waitForAPI: ->
    window.clearTimeout @waitForAPITimeout
    do repeat = =>
      if window.YT?.Player?
        @createPlayer()
      else
        @waitForAPITimeout = window.setTimeout(repeat, 100)

  playVideo: ->
    window.clearTimeout @checkForPlayerTimeout
    do repeat = =>
      if @player?.playVideo?
        @player?.playVideo?()
      else
        @checkForPlayerTimeout = window.setTimeout(repeat, 100)

  createPlayer: ->
    el = @findOne(".yt-player")

    @player = new YT.Player el,
      videoId: @options.data.videoId
      playerVars:
        autoplay: 0
        controls: device.platform == 'Android'
        modestbranding: 0
        showinfo: 0
        rel: 0
        start: parseInt(@options.data.startTime, 10) or 0
        end: parseInt(@options.data.endTime, 10) or undefined
      events:
        onReady: =>
          @setState("paused", "video")
        onStateChange: (e) =>
          switch e.data
            when YT.PlayerState.PLAYING then @setState("playing", "video")
            when YT.PlayerState.PAUSED  then @setState("paused", "video")
            when YT.PlayerState.ENDED   then @onVideoEnded()

  onRefresh: ->
    @beforeShow(true)

  onVideoEnded: () ->
    autoProgress = if @options.data?.autoProgress? then @options.data.autoProgress else true

    if autoProgress
      @submit()
    else
      @setState("touched")
      @findOne(".btn-done").innerHTML = i18n("buttons.continue")

  submit: (e) ->
    e?.stopImmediatePropagation()
    super

module.exports = YoutubeVideoEmbedView
